export default "__VITE_ASSET__CLbjtT12__"